/*
* @Author: gujianghua
* @Date:   2018-07-20 11:23:39
* @Last Modified by:   gujianghua
* @Last Modified time: 2018-08-09 11:48:50
*/
import { service } from '@/utils/request'

export default {
	/**
	 * [getTagList 获取标签列表]
	 * @return
	 */
	getTagList(params) {
		return service ({
			url: '/cloud/statistic/tagManege/tagInfoDtoPage',
			method: 'get',
            params
		})
	},
	/**
	 * [editTag 编辑标签]
	 * @param  {[type]} params [标签id,标签名，type:1-标签组，2-标签]
	 * @return
	 */
     saveOrUpdateTagInfo: function editTag(data) {
		return service ({
			url: '/cloud/statistic/tagManege/saveOrUpdateTagInfo',
			method: 'post',
			data
		})
	},
	/**
	 * [getTagList 获取标签分类列表]
	 * @return
	 */
     tagGroupDtoPage(data) {
		return service ({
			url: '/cloud/statistic/tagManege/tagGroupDtoPage',
			method: 'get',
			params: data
		})
	},
}


// WEBPACK FOOTER //
// ./src/api/contentManage/tagmanage2.js